import { type GeoLocation } from '../types';

export const parseGeolocationUrlParam = (
  paramValue: string
): GeoLocation | undefined => {
  const [latitudeStr, longitudeStr] = paramValue.split(',');
  if (!latitudeStr || !longitudeStr) {
    return undefined;
  }

  const latitude = parseFloat(latitudeStr);
  const longitude = parseFloat(longitudeStr);

  if (isNaN(latitude) || isNaN(longitude)) {
    return undefined;
  }
  return {
    latitude,
    longitude,
  };
};

export const serializeGeolocationToUrlParam = (
  geolocation: GeoLocation
): string => {
  return `${geolocation.latitude},${geolocation.longitude}`;
};
